<template>
    <div class="p-4 bg-yellow-200 rounded border border-yellow-300 flex items-center justify-between text-yellow-800">
        <div class="flex items-center">
            <i class="far fa-trash mr-1" />
            <slot />
        </div>

        <!-- <button class="text-yellow-800 hover:underline" tabindex="-1" type="button" @click="$emit('restore')">
            <i class="fal fa-trash-undo mr-1"></i>Restore
        </button> -->
    </div>
</template>

<script>
export default {};
</script>
